export const USE_MOCK = false;

export const SCHOOLS_API = "/api/schools";

export const EMPTY_FILTERS = { shift: "", lang: "", status: "" };

export const STATUS_COLOR = {
  good: "#57c15d",
  bad: "#e0605f",
  no_data: "#8b95a8",
};

export const CATEGORY_COLORS = ["#4a90d9", "#a06fd6", "#3fa9b5", "#c78a3f"];

export const CAP_COLOR = "#3a4456";

export const BAR_ROW_H = 34;
